import { createComponent } from '@carvana/merch-components';

export const BannerContainer = createComponent('div', {
  className: 'flex min-h-[128px] w-full overflow-hidden rounded-xl'
});

export const InnerWrapper = createComponent('div', {
  className:
    'flex h-full w-full items-center justify-between py-xl pl-2xl pr-md sm:px-4xl sm:py-0 lg:py-4xl lg:pl-7xl lg:pr-4xl'
});

export const LeftSectionBanner = createComponent('div', {
  className: 'flex flex-col items-start gap-lg'
});

export const HeadlineBanner = createComponent('h2', {
  className:
    'text-text-inverse t-heading-xs sm:t-heading-lg md:max-w-[520px] lg:max-w-[540px] lg:t-heading-2xl'
});

export const RightSectionBanner = createComponent('div', {
  className: 'flex h-[96px] min-w-[120px] sm:h-[192px] sm:shrink-0 lg:h-[205px]'
});
